import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=3bad8a55&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad8a55",
  null
  
)

export default component.exports